import { Chip } from '@ntuctech/devex-tangram'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import styled from 'styled-components'
import { Router } from '../../routes'
import { withRouter } from 'next/router'
import React, { Component } from 'react'
import GlobalContext from '../GlobalContext'
import { CheckoutAddressConsumer } from '../CheckoutAddressProvider/CheckoutAddressProvider'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR } from '../../lib/eventTrackerFunction'
import { AMP_EVENT_NAME as AEN, getPageTypeByUrl } from '../../lib/amplitude'
import { SCREEN_SIZE } from '../../lib/Media'
import Carousel from '../Carousel/Carousel'

export const SearchSuggestionsContainer = styled.section`
  margin-bottom: 1.5rem;
  width: 100%;
  ${SCREEN_SIZE.From.Desktop} {
    width: calc(100% - 1.5rem);
  }
`

class SearchSuggestionCollectionWrapper extends Component {
  constructor(props) {
    super(props)
    this.handleSearch = this.handleSearch.bind(this)
  }

  handleSearch = item => {
    const GEV = GTM_ENV_VAR
    const refinementItems = this.props.data.collection.length
      ? this.props.data.collection.filter(
          suggestion => suggestion.suggestionType === 'keyword'
        )
      : []
    const getSelectedItemIndex = this.props.data.collection.length
      ? this.props.data.collection
          .filter(collection => collection.suggestionType === 'keyword')
          .findIndex(
            selectedSuggestion => item.name === selectedSuggestion.name
          )
      : ''

    const defaultFeatureCount = {
      'refinement items': refinementItems.length,
    }

    const actualFeatureCount = []

    for (const label in defaultFeatureCount) {
      if (defaultFeatureCount[label]) {
        actualFeatureCount.push(`${label}: ${defaultFeatureCount[label]}`)
      }
    }

    const defaultFeatureContent = {
      'refinement items': refinementItems.map(val => val.name).join(),
    }

    const actualFeatureContent = []

    for (const label in defaultFeatureContent) {
      if (defaultFeatureContent[label]) {
        actualFeatureContent.push(`${label}: ${defaultFeatureContent[label]}`)
      }
    }

    this.props.track({
      [GEV.AMPLITUDE_EVENT_NAME]: AEN.SEARCH_COMPLETED,
      [GEV.KEYWORD_SELECTED]: item.name,
      [GEV.AMPLITUDE_SEARCH_FEATURE_SELECTED]: 'refinement',
      [GEV.AMPLITUDE_ITEM_POSITIONS]: getSelectedItemIndex + 1,
      [GEV.SEARCH_FEATURES_COUNT]: actualFeatureCount,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: [this.props.router.query.query] || [],
      },
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: 'chips',
      [GEV.SEARCH_FEATURES_COUNT]: actualFeatureCount,
      // // GA
      [GEV.EVENT_CAT]: 'product-core',
      [GEV.EVENT_ACTION]: 'searchcomplete',
      [GEV.EVENT_LABEL]: JSON.stringify({
        SearchFeatureSelected: 'refinement',
      }),
      [GEV.SCREEN_NAME]: 'Search Result',
      [GEV.PAGE_TYPE]: 'Search',
      [GEV.KEYWORD_SELECTED]: item.name,
      [GEV.ASSET_TYPE]: 'FPON',
      [GEV.SEARCH_POSITION]: getSelectedItemIndex + 1,
      [GEV.SUGGESTED_KEYWORD_IMPRESSION]: actualFeatureContent,
      [GEV.SUGGESTED_SEARCH_IMPRESSION]: actualFeatureContent,
      [GEV.FUL_CENTER]: this.props.checkoutAddress?.storeType,
    })
    Router.pushRoute(`/search?query=${encodeURIComponent(item.name)}`)
  }

  render() {
    const { data } = this.props
    return (
      <NdsThemeProvider>
        <SearchSuggestionsContainer data-testid="search-suggestions">
          <Carousel infiniteScrolling hasMore>
            {data.collection.length &&
              data.collection.map((item, index) => {
                return (
                  <Chip
                    data-testid="search-suggestion-item"
                    key={item.name + index}
                    label={item.name}
                    onClick={() => this.handleSearch(item)}
                  />
                )
              })}
          </Carousel>
        </SearchSuggestionsContainer>
      </NdsThemeProvider>
    )
  }
}

const SearchSuggestionCollection = props => (
  <GlobalContext.Consumer>
    {({ remoteConfig, experiments }) => (
      <CheckoutAddressConsumer>
        {({ checkoutAddress }) => (
          <EventTrackingConsumer>
            {({ track, getTestVersions }) => (
              <React.Fragment>
                <div />
                {/* Needed for avoiding layout shifting in the home page */}
                <SearchSuggestionCollectionWrapper
                  checkoutAddress={checkoutAddress}
                  {...props}
                  track={track}
                  remoteConfig={remoteConfig}
                  experiments={experiments}
                  getTestVersions={getTestVersions}
                />
              </React.Fragment>
            )}
          </EventTrackingConsumer>
        )}
      </CheckoutAddressConsumer>
    )}
  </GlobalContext.Consumer>
)

export default withRouter(SearchSuggestionCollection)
